import { Injectable } from '@angular/core';
import { ApiService } from "../api-service/api-service";

/*
  Generated class for the SocialServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SocialService {

  constructor(public apiSer: ApiService) {

  }


  // http://www.overdose.com/api/user.interest/delete?user_id=1&interest_id=1
  userInterestDelete(params?: any) {
    let seq = this.apiSer.get('api/user.interest/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // http://www.overdose.com/api/user.interest/count?token=e7fa934ba4049f87cc1f112e1cbfe4aa&user_id=1
  userInterestCount(params?: any) {
    let seq = this.apiSer.get('api/user.interest/count', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // http://www.overdose.com/api/user.interest?token=e7fa934ba4049f87cc1f112e1cbfe4aa&user_id=1
  userInterest(params?: any) {
    let seq = this.apiSer.get('api/user.interest', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // http://www.overdose.com/api/user.interest/report?token=e7fa934ba4049f87cc1f112e1cbfe4aa&user_id=1
  userInterestReport(params?: any) {
    let seq = this.apiSer.post('api/user.interest/report', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 兴趣领域获取
   * http://www.overdose.com/api/common.category?type=interest
   * @param params
   * @return {Observable<any>}
   */
  commonInterest(params?: any) {
    let seq = this.apiSer.get('api/common.category', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // moment首页
  socialMomentHome(url:string,params?: any)
  {

    let seq = this.apiSer.get('v1/'+url, params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 用户朋友圈列表
   * @param {string} url http://www.overdose.com/v1/moment?user_id=1&moment_user_id=1
   * @param params
   * @return {Observable<any>}
   */
  socialMomentUser(url:string, params?: any) {
    let seq = this.apiSer.get('v1/' +url, params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 发布DOSE
   * http://www.overdose.com/v1/social/moment/image/publish?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  socialMomentImagePublish (params?: any) {
    let seq = this.apiSer.post('v1/moment/image/publish', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // http://www.overdose.com/v1/social/moment/delete?user_id=1&moment_id=4
  socialMomentDelete (params?: any) {
    let seq = this.apiSer.get('v1/moment/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // DOSE详情
  // http://www.overdose.com/v1/social/moment?user_id=1&moment_id=1
  socialMomentDetail(params?: any) {
    let seq = this.apiSer.get('v1/moment/show', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }




  // 发布朋友圈评论
  // http://nana-api.tp13.com/moment/comment/publish
 socialMomentCommentPublish(params?: any) {
    let seq = this.apiSer.post('v1/moment/comment/publish', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // 回复朋友圈评论
  // http://nana-api.tp13.com/moment/comment/reply
  socialMomentCommentReply(params?: any) {
    let seq = this.apiSer.post('v1/moment/comment/reply', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  // 删除朋友圈评论
  // http://nana-api.tp13.com/moment/comment/delete/by
  socialMomentCommentDelete(params?: any) {
    let seq = this.apiSer.get('v1/moment/comment/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // 朋友圈评论列表
  // http://nana-api.tp13.com/moment/comment
  socialMomentCommentPost(params?: any) {
    let seq = this.apiSer.post('v1/moment/comment', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  socialMomentCommentGet(params?: any) {
    let seq = this.apiSer.get('v1/moment/comment', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }



  // 操作
  // 喜欢DOSE
  socialMomentLike(params?: any) {
    let seq = this.apiSer.get('v1/moment/like', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // 收藏DOSE
  socialMomentFavorite(params?: any) {
    let seq = this.apiSer.get('v1/moment/favorite', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  socialMomentShare(params?: any) {
    let seq = this.apiSer.get('v1/moment/share', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  // http://www.overdose.com/v1/social/moment/comment/like?user_id=1&comment_id=1
  // 喜欢评论

  socialMomentCommentLike(params?: any) {
    let seq = this.apiSer.get('v1/moment/comment/like', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // 关注用户
  // http://www.overdose.com/v1/social/moment/user/follow?user_id=1&follow_id=2
  socialMomentUserFollow(params?: any) {
    let seq = this.apiSer.get('v1/moment/user/follow', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  // 用户关注数
  // http://www.overdose.com/v1/social/moment/user/follows?user_id=1&view_user_id=6
  socialMomentUserFollows(params?: any) {
    let seq = this.apiSer.get('v1/moment/user/follows', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // http://www.overdose.com/v1/social/moment/user/fans?user_id=1&view_user_id=1
  socialMomentUserFans(params?: any) {
    let seq = this.apiSer.get('v1/moment/user/fans', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service/social-service.ts